import { HttpClient } from '../httpClient';
import CaseloadsResponse from '../responses/caseloadsResponse';
import TransferCaseloadResponse from '../responses/TransferCaseloadResponse';
import CaseloadResponse from '../responses/caseloadResponse';
import CaseloadAddNewRequest from '../requests/caseloadAddNewRequest';
import CaseloadAddExistingRequest from '../requests/caseloadAddExistingRequest';
import CaseloadUpdateRequest from '../requests/caseloadUpdateRequest';
import CaseloadDischargeRequest from '../requests/caseloadDischargeRequest';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import CaseloadsDisplayResponse from '../responses/caseloadsDisplayResponse';
import CaseloadTransferRequest from '../requests/caseloadTransferRequest';
import CaseloadDisplayResponse from '../responses/caseloadDisplayResponse';
import caseloadDisplay from '../models/caseloadDisplay';
import StudentDiscipline from '../models/studentdiscipline';
import AdditionalCaseloadsResponse from '../responses/additionalCaseloadsResponse';
import CaseloadRemoveRequest from '../requests/caseloadRemoveRequest';
import CaseloadApprovalRequest from '../requests/caseloadApprovalRequest';
import CaseloadRejectionModel from '../models/caseloadRejectionModel';
import ChangeStudentSchoolRequest from '../requests/changeStudentSchoolRequest';


const httpClient = new HttpClient();

export const getCaseloads = async () => {
  return httpClient.get<CaseloadsResponse>({
    url: `/v1/caseloads`,
    requiresToken: true,
  });
};

export const getCaseloadsByDisciplineId = async (disciplineId: number | undefined = undefined) => {
  return httpClient.get<CaseloadsResponse>({
    url: `/v1/caseloads${disciplineId !== undefined && disciplineId !== -1 ? `?disciplineId=${disciplineId}` : ``}`,
    requiresToken: true,
  });
};

export const getCaseload = async (caseloadId: number) => {
  return httpClient.get<CaseloadResponse>({
    url: `/v1/caseloads/${caseloadId}`,
    requiresToken: true,
  });
};

export const getCaseloadByTherapist = async (
  /*   disciplineId: number,
  firstName: string, */
  lastName: string
  /* dob: string */
) => {
  return httpClient.get<CaseloadsResponse>({
    /*     url: `/v1/students/with-caseload?disciplineId=${disciplineId}&firstName=${firstName}&lastName=${lastName}&dob=${dob}`, */
    url: `/v1/Caseloads/caseloadByTherapy?isMulti=true&studentLastName=${lastName}&therapist=&currentSchool=&currentSchool=&currentStatus=&therapyType=&district=`,
    requiresToken: true,
  });
};

export const searchCaseloads = async (
  name: string = '',
  therapistId: number = -1,
  statusId: number = -1,
  districtId: number = -1,
  schoolId: number = -1,
  programId: number = -1,
  disciplineId: number = -1,
  grade: number = -1,
  therapistRole: number = -1,
  therapistName: string | null = null,
  disciplineName: string = '',
  districtName: string = '',
  schoolName: string = ''
) => {
  //Process any potential nulls
  const therapist = therapistId === -1 ? '' : therapistId;
  const status = statusId === -1 ? '' : statusId;
  const program = programId === -1 ? '' : programId;
  const discipline = disciplineId === -1 ? '' : disciplineId;
  const district = districtId === -1 ? '' : districtId;
  const school = schoolId === -1 ? '' : schoolId;
  const gradeId = grade === -1 ? '' : grade;
  const therapistRoleId = therapistRole === -1 ? '' : therapistRole;

  return httpClient.get<CaseloadsResponse>({
    url: `/v1/Billing/Caseloads/search?isMulti=true&name=${name}&therapistId=${therapist}&schoolId=${school}&programId=${program}&statusId=${status}&districtId=${district}&disciplineId=${discipline}&grade=${gradeId}&therapistRole=${therapistRoleId}&therapistName=${therapistName}&disciplineName=${disciplineName}&districtName=${districtName}&schoolName=${schoolName}`,
    requiresToken: true,
  });
};

export const searchAdminCaseloads = async (
  name: string = '',
  therapistId: number = -1,
  statusId: number = -1,
  districtId: number = -1,
  schoolId: number = -1,
  programId: number = -1,
  disciplineId: number = -1,
  grade: number = -1,
  therapistRole: number = -1,
  therapistName: string | null = null,
  disciplineName: string = '',
  districtName: string = '',
  schoolName: string = '',
) => {

  //Process any potential nulls
  const therapist = therapistId === -1 ? '' : therapistId;
  const status = statusId === -1 ? '' : statusId;
  const program = programId < 0 ? '' : programId;
  const discipline = disciplineId === -1 ? '' : disciplineId;
  const district = districtId === -1 ? '' : districtId;
  const school = schoolId === -1 ? '' : schoolId;
  const gradeId = grade === -1 ? '' : grade;
  const therapistRoleId = therapistRole === -1 ? '' : therapistRole;

  return httpClient.get<CaseloadsResponse>({
    url: `/v1/Billing/Caseloads/adminSearch?isMulti=true&name=${name}&therapistId=${therapist}&schoolId=${school}&programId=${program}&statusId=${status}&districtId=${district}&disciplineId=${discipline}&grade=${gradeId}&therapistRole=${therapistRoleId}&therapistName=${therapistName}&disciplineName=${disciplineName}&districtName=${districtName}&schoolName=${schoolName}`,
    requiresToken: true,
  });
};

export const getPendingCaseloads = async () => {
  return httpClient.get<CaseloadsDisplayResponse>({
    url: `/v1/Billing/Caseloads/pending`,
    requiresToken: true,
  });
};

export const getRejectedCaseloadsByTherapistId = async (therapistId: number) => {
  return httpClient.get<DataResponse<CaseloadRejectionModel>>({
    url: `/v1/Caseloads/Rejected/Therapist/${therapistId}`,
    requiresToken: true,
  });
};

export const getRejectedCaseloadsByTherapistUser = async (userId: number, disciplineId: number) => {
  return httpClient.get<DataResponse<CaseloadRejectionModel>>({
    url: `/v1/Caseloads/Rejected/User/${userId}/${disciplineId}`,
    requiresToken: true,
  });
};

export const getCaseloadDetails = async (caseloadId: number) => {
  return httpClient.get<CaseloadResponse>({
    url: `/v1/caseloads/${caseloadId}/details`,
    requiresToken: true,
  });
};

export const addNewStudentToCaseload = async (
  caseloadrequest: CaseloadAddNewRequest
) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/caseloads/add-new',
    payload: caseloadrequest,
    requiresToken: true,
  });
};

export const addExistingStudentToCaseload = async (
  caseloadrequest: CaseloadAddExistingRequest
) => {
  return httpClient.post<CaseloadResponse>({
    url: '/v1/caseloads/add-existing',
    payload: caseloadrequest,
    requiresToken: true,
  });
};

export const removeStudentFromCaseload = async (
  caseloadrequest: CaseloadRemoveRequest
) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/caseloads/removeStudent',
    payload: caseloadrequest,
    requiresToken: true,
  });
};

export const updateCaseload = async (
  caseloadId: number,
  caseloadrequest: CaseloadUpdateRequest
) => {
  return await httpClient.put<any>({
    url: `/v1/caseloads/${caseloadId}`,
    payload: caseloadrequest,
    requiresToken: true,
  });
};

export const batchUpdateManyCaseloads = async (caseloadrequests: CaseloadUpdateRequest[]) => {
  return await httpClient.put<BaseResponse>({
    url: `/v1/caseloads/BatchUpdateCaseloads`,
    payload: caseloadrequests,
    requiresToken: true,
  });
};

export const dischargeFromDiscipline = async (
  caseloadId: number,
  caseloadrequest: CaseloadDischargeRequest
) => {
  return httpClient.post<BaseResponse>({
    url: `/v1/caseloads/discharge/${caseloadId}`,
    payload: caseloadrequest,
    requiresToken: true,
  });
};

export const approveCaseload = async (caseloadId: number) => {
  return httpClient.put<CaseloadsDisplayResponse>({
    url: `/v1/Billing/caseloads/approve/${caseloadId}`,
    requiresToken: true,
  });
};

export const rejectCaseload = async (caseloadId: number, request: CaseloadApprovalRequest) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/Billing/caseloads/reject/${caseloadId}`,
    payload: request,
    requiresToken: true,
  });
};

export const transferCaseload = async (
  caseloadrequest: CaseloadTransferRequest
) => {
  return httpClient.put<TransferCaseloadResponse>({
    url: `/v1/Billing/caseloads/transfer`,
    payload: caseloadrequest,
    requiresToken: true,
  });
};

export const getCaseloadsFromArray = async (caseloadIds: number[]) => {
  //We return all promises so that the function does not return prematurely, before all asyncs are finished
  return Promise.all(
    caseloadIds.map(async (id) => {
      return await httpClient.get<CaseloadResponse>({
        url: `/v1/Billing/caseloads/${id}`,
        requiresToken: true,
      });
    })
  );
};

export const getCaseloadDisplayFromArray = async (caseloadIds: number[]) => {
  //We return all promises so that the function does not return prematurely, before all asyncs are finished
  return Promise.all(
    caseloadIds.map(async (id) => {
      return await httpClient.get<CaseloadDisplayResponse>({
        url: `/v1/Billing/caseloads/${id}`,
        requiresToken: true,
      });
    })
  );
};

export const batchUpdateCaseloads = async (caseloads: caseloadDisplay[]) => {
  return httpClient.post<BaseResponse>({
    url: `/v1/caseloads/batchUpdate`,
    requiresToken: true,
    payload: caseloads,
  });
};

export const getStudentDisciplinesByCaseloadId = async (caseloadId: number) => {
  return httpClient.get<DataResponse<StudentDiscipline[]>>({
    url: `/v1/caseloads/${caseloadId}/StudentDisciplines`,
    requiresToken: true,
  });
};

export const getCaseloadsByStudentDisciplineId = async (studentId: number, caseloadId: number, disciplineId: number) => {
  return httpClient.get<AdditionalCaseloadsResponse>({
    url: `/v1/caseloads/ByStudent/${studentId}/${caseloadId}/${disciplineId}`,
    requiresToken: true,
  });
};

export const changeStudentSchool = async (model: ChangeStudentSchoolRequest) => {
  return httpClient.post<DataResponse<any>>({
    url: `/v1/Billing/Caseloads/ChangeStudentSchool`,
    requiresToken: true,
    payload: model,
  });
}